import styled from "styled-components";

const IconText = styled.p({
  marginTop: 6,
  alignItems: "flex-start",
  display: "flex",
  justifyContent: "center",
  width: 100,
  textAlign: "center",
  breakAfter: "auto",
  wordBreak: "break-all",
  color: "white",
});

export default IconText;
